import request from '@/utils/http';

// 查询
export const getAiRecordInfos = (data) => {
    return request({
        url: `/api-otp/aiRecordInfos`,
        method: 'post',
        data
    });
};
// 数量接口
export const aiRecordInfosCount = (data) => {
    return request({
        url: `/api-otp/aiRecordInfosCount`,
        method: 'post',
        data
    });
};
